module.exports = __webpack_public_path__ + "img/vende_tu_auto_paso2_tablet.2e86c82e.png";